var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconFire(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    fill: "#F4F4F4"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_123_10189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1472 7.93554L12.9678 7.54791L11.3076 3.69281C11.1913 3.42287 10.8086 3.42287 10.6924 3.69281L9.0322 7.54788L4.85279 7.93554C4.56013 7.96266 4.44188 8.32666 4.66266 8.52063L7.81604 11.2908L6.8932 15.3855C6.82857 15.6722 7.13823 15.8971 7.39092 15.7471L11 13.6041L14.6091 15.7471C14.8618 15.8972 15.1714 15.6722 15.1068 15.3855L14.1839 11.2908L17.3373 8.52063C17.5581 8.32666 17.4398 7.96266 17.1472 7.93554Z",
    fill: "#D93B0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.72751 3.56007C6.94057 3.85601 7.54194 5.12695 7.88576 5.86764C7.93982 5.98408 7.79373 6.08927 7.70045 6.00105C7.1071 5.44005 6.09257 4.46654 5.8795 4.17057C5.71091 3.93642 5.76407 3.60992 5.99825 3.44132C6.23241 3.27273 6.55891 3.32592 6.72751 3.56007Z",
    fill: "url(#paint0_linear_123_10189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2725 3.56007C15.0594 3.85601 14.458 5.12695 14.1142 5.86764C14.0601 5.98408 14.2062 6.08927 14.2995 6.00105C14.8929 5.44005 15.9074 4.46651 16.1205 4.17057C16.2891 3.93642 16.2359 3.60992 16.0017 3.44132C15.7676 3.27273 15.4411 3.32592 15.2725 3.56007Z",
    fill: "url(#paint1_linear_123_10189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6395 12.2384C18.2928 12.1254 16.8992 11.9386 16.0891 11.8361C15.9618 11.82 15.906 11.9911 16.0183 12.0532C16.7331 12.448 17.9688 13.1188 18.3155 13.2318C18.5898 13.3213 18.8847 13.1715 18.9742 12.8971C19.0637 12.6228 18.9138 12.3279 18.6395 12.2384Z",
    fill: "url(#paint2_linear_123_10189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.36058 12.2384C3.70727 12.1254 5.10086 11.9386 5.91096 11.8361C6.0383 11.82 6.09412 11.9911 5.98177 12.0532C5.26699 12.448 4.03127 13.1188 3.68458 13.2318C3.41027 13.3213 3.11536 13.1715 3.02589 12.8971C2.93642 12.6228 3.08627 12.3279 3.36058 12.2384Z",
    fill: "url(#paint3_linear_123_10189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4937 18.1347C10.4937 17.7701 10.7482 16.3872 10.9019 15.5853C10.9261 15.4592 11.1061 15.4592 11.1303 15.5853C11.284 16.3872 11.5386 17.7701 11.5386 18.1347C11.5386 18.4232 11.3047 18.6572 11.0161 18.6572C10.7276 18.6572 10.4937 18.4232 10.4937 18.1347Z",
    fill: "url(#paint4_linear_123_10189)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9113 5.09469L11.3075 3.69281C11.1913 3.42287 10.8086 3.42287 10.6924 3.69281L9.03217 7.54788L4.85279 7.93554C4.56013 7.96266 4.44188 8.32666 4.66266 8.52063L7.81604 11.2908L6.8932 15.3855C6.82857 15.6722 7.13823 15.8971 7.39091 15.7471L7.87126 15.4619C8.65873 10.3644 10.8725 6.62244 11.9113 5.09469Z",
    fill: "#911906"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_123_10189",
    x1: 6.83922,
    y1: 3.34283,
    x2: 6.83922,
    y2: 6.03384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D18228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_123_10189",
    x1: 15.1608,
    y1: 3.34283,
    x2: 15.1608,
    y2: 6.03384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D18228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_123_10189",
    x1: 17.4789,
    y1: 11.835,
    x2: 17.4789,
    y2: 13.2577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D18228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_123_10189",
    x1: 4.52116,
    y1: 11.835,
    x2: 4.52116,
    y2: 13.2577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D18228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FF00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_123_10189",
    x1: 11.0161,
    y1: 15.4907,
    x2: 11.0161,
    y2: 18.6572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D18228"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7FF00"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_123_10189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFire);
export default __webpack_public_path__ + "static/media/icon_fire.d1a65b7b72b5fead893620ea1effdf4f.svg";
export { ForwardRef as ReactComponent };